import React from 'react';
import { BookIcon, HeartIcon, CompassIcon, SparklesIcon } from 'lucide-react';
export const Features = () => {
  return <section className="py-12 sm:py-16 bg-white" data-id="element-116">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-117">
        <div className="text-center" data-id="element-118">
          <h2 className="text-base text-[#990000] font-semibold tracking-wide uppercase" data-id="element-119">
            What's Inside
          </h2>
          <p className="mt-2 text-2xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-3xl md:text-4xl" data-id="element-120">
            A treasure of wisdom for generations
          </p>
        </div>
        <div className="mt-8 sm:mt-10" data-id="element-121">
          <div className="space-y-8 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10" data-id="element-122">
            <div className="flex" data-id="element-123">
              <div className="flex-shrink-0" data-id="element-124">
                <div className="flex items-center justify-center h-10 w-10 sm:h-12 sm:w-12 rounded-md bg-[#990000] text-white" data-id="element-125">
                  <BookIcon className="h-5 w-5 sm:h-6 sm:w-6" data-id="element-126" />
                </div>
              </div>
              <div className="ml-4" data-id="element-127">
                <h3 className="text-base leading-6 font-medium text-gray-900 sm:text-lg" data-id="element-128">
                  Stories that teach timeless values
                </h3>
                <p className="mt-2 text-sm sm:text-base text-gray-500" data-id="element-129">
                  Engaging narratives that illustrate the importance of
                  character, integrity, and perseverance.
                </p>
              </div>
            </div>
            <div className="flex" data-id="element-130">
              <div className="flex-shrink-0" data-id="element-131">
                <div className="flex items-center justify-center h-10 w-10 sm:h-12 sm:w-12 rounded-md bg-[#990000] text-white" data-id="element-132">
                  <HeartIcon className="h-5 w-5 sm:h-6 sm:w-6" data-id="element-133" />
                </div>
              </div>
              <div className="ml-4" data-id="element-134">
                <h3 className="text-base leading-6 font-medium text-gray-900 sm:text-lg" data-id="element-135">
                  Reflections on faith, freedom, and perseverance
                </h3>
                <p className="mt-2 text-sm sm:text-base text-gray-500" data-id="element-136">
                  Thoughtful meditations on the principles that have guided
                  generations of Americans.
                </p>
              </div>
            </div>
            <div className="flex" data-id="element-137">
              <div className="flex-shrink-0" data-id="element-138">
                <div className="flex items-center justify-center h-10 w-10 sm:h-12 sm:w-12 rounded-md bg-[#990000] text-white" data-id="element-139">
                  <CompassIcon className="h-5 w-5 sm:h-6 sm:w-6" data-id="element-140" />
                </div>
              </div>
              <div className="ml-4" data-id="element-141">
                <h3 className="text-base leading-6 font-medium text-gray-900 sm:text-lg" data-id="element-142">
                  A roadmap for living with purpose
                </h3>
                <p className="mt-2 text-sm sm:text-base text-gray-500" data-id="element-143">
                  Practical guidance for navigating life's challenges while
                  staying true to your values.
                </p>
              </div>
            </div>
            <div className="flex" data-id="element-144">
              <div className="flex-shrink-0" data-id="element-145">
                <div className="flex items-center justify-center h-10 w-10 sm:h-12 sm:w-12 rounded-md bg-[#990000] text-white" data-id="element-146">
                  <SparklesIcon className="h-5 w-5 sm:h-6 sm:w-6" data-id="element-147" />
                </div>
              </div>
              <div className="ml-4" data-id="element-148">
                <h3 className="text-base leading-6 font-medium text-gray-900 sm:text-lg" data-id="element-149">
                  Inspiration for the next generation
                </h3>
                <p className="mt-2 text-sm sm:text-base text-gray-500" data-id="element-150">
                  Motivational passages that encourage young people to embrace
                  their heritage and build upon it.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};